import JSZip from 'jszip';

export async function readXmlFromZip(uploadedFile: File) {
  const zip = new JSZip();
  const zipContent = await zip.loadAsync(uploadedFile);

  const xmlFiles = Object.keys(zipContent.files).filter(name => name.endsWith('.xml'));

  if (xmlFiles.length === 0) {
    throw new Error('No XML file found in the uploaded zip.');
  }

  const xmlContent = await zipContent.files[xmlFiles[0]].async('text');

  if (!xmlContent.trim()) {
    throw new Error('The XML file is empty.');
  }

  return xmlContent;
}
